import script from "./schoolProblemFeedForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./schoolProblemFeedForm.vue?vue&type=script&lang=ts&setup=true"

import "./schoolProblemFeedForm.vue?vue&type=style&index=0&id=020e08f6&scoped=true&lang=css"

import exportComponent from "D:\\WorkFile\\Project\\uniapp-bajitu-user\\web-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-020e08f6"]])

export default __exports__